import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation, useNavigate } from "react-router-dom";
import { getSearchWithoutAuth0CallbackParams } from "../utils/auth0Cache";

/**
 * After Auth0 finishes loading, remove one-time OAuth callback params from the URL.
 * Leaving ?code=&state= causes refresh to replay the callback and send the user back to login.
 */
export const useStripAuth0CallbackParams = () => {
  const { isLoading } = useAuth0();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    const { search: cleanSearch, changed } = getSearchWithoutAuth0CallbackParams(
      location.search
    );
    if (!changed) return;

    navigate({ pathname: location.pathname, search: cleanSearch }, { replace: true });
  }, [isLoading, location.pathname, location.search, navigate]);
};
